

import { fullMiningType, fullSolType } from "Components/Content/configurationArea/Business/system";
import { encodeBase64 } from "Components/Logics/ensoCommonFunctions";
import {
  ROLE,
  STATUS,
  caseSubTypes,
  caseTypesMap,
  extensionOfferTools,
  mpwSegmentSolution,
  sCRMRegex,
  salesChannelLogic,
  toolRedirect,
} from "Components/Misc/CaseDetails_System";
import OOT from "Constants/services/oot";
import {
  changeAppState,
  resetAuth,
  setAccount,
  setError,
  showLoader,
  showModal,
  updateAccount,
} from "Store/general/auth";
import { totalCost } from "Store/contentState/cartBoqSlice";
import { resetCD, setData, setOBJ, setStatus } from "Store/contentState/caseDetails/caseDetailsSlice";
import { resetFC } from "Store/contentState/caseDetails/findCaseSlice";
import { RootState, store } from "Store/mainStore";
import { setLive, setVisible } from "Store/general/theme";
import { generateSyncOfferItems, isHardwareSLAItem } from "Utils";
import _, { find } from 'lodash';
import { getStateOfElement } from "./stateMachine/modules/CONFIG/configurator_statelogics";
import useDatamart from "Components/Content/configurationArea/Configurator/hooks/useDatamart";
import DATAMART_SERVICES from "Constants/services/datamart_services";
import { getUIJsonState } from "Constants/services/common";
import { setProp } from "Store/Actions";

const CUSTOM_ACTIONS = {
  DEFAULT: 'default',
  MODIFIED: 'modified',
  DELETED: 'deleted'
}
/* LOGIC FOR SALES CHANNEL */

export const handleSalesChannelLogic = (state) => {
  //const state = store.getState();

  const selectedSalesChannel = state.caseDetails.data.sales_channel;

  if (selectedSalesChannel) {
    if (selectedSalesChannel === "DIR") {
      //  store.dispatch(setData({ key: 'endCustomer', value: state.caseDetails.data.account }))
      store.dispatch(
        setData({ key: "endCustomer", value: state.caseDetails.data.endCustomer })
      );
      store.dispatch(setData({ key: "distributor", value: "" }));
      store.dispatch(setData({ key: "resellers", value: "" }));
      store.dispatch(setData({ key: "indirect_resellers", value: "" }));
    }
    if (selectedSalesChannel === "DIS") {
      store.dispatch(
        setData({
          key: "endCustomer",
          value: state.caseDetails.data.endCustomer,
        })
      );
      store.dispatch(
        setData({ key: "distributor", value: state.caseDetails.data.account })
      );
      store.dispatch(setData({ key: "resellers", value: "" }));
      store.dispatch(
        setData({
          key: "indirect_resellers",
          value: state.caseDetails.data.indirect_resellers,
        })
      );
    }
    if (selectedSalesChannel === "RES") {
      store.dispatch(
        setData({
          key: "endCustomer",
          value: state.caseDetails.data.endCustomer,
        })
      );
      store.dispatch(setData({ key: "distributor", value: "" }));
      store.dispatch(
        setData({ key: "resellers", value: state.caseDetails.data.account })
      );
      store.dispatch(setData({ key: "indirect_resellers", value: "" }));
    }
    switch (state.caseDetails.data.sales_channel) {
      case selectedSalesChannel:
        store.dispatch(
          setVisible({
            id: salesChannelLogic[selectedSalesChannel].visible,
            value: true,
          })
        ); //stopped due to max stack error
        store.dispatch(
          setVisible({
            id: salesChannelLogic[selectedSalesChannel].hidden,
            value: false,
          })
        );
        break;
      default:
        break;
    }
    handleCaseDepSaleChannelLogic(state); //Makes fields R / O on the basis of casetype
  }
};

export const handleRestLogic = () => {
  store.dispatch(resetAuth());
  store.dispatch(resetFC());
  store.dispatch(resetCD());
};

export const handleAccountLogic = (oot_response, state) => {
  if (!oot_response.data.sales_channel.default) {
    return;
  }

  switch (oot_response.data.sales_channel.default) {
    case "DIR":
      store.dispatch(
        updateAccount({
          id: oot_response.data.end_customer.nid,
          value: oot_response.data.end_customer.name,
          account_id: oot_response.data.end_customer.account_id,
          type: "account",
        })
      );

      store.dispatch(
        updateAccount({
          id: oot_response.data.end_customer.nid,
          value: oot_response.data.end_customer.name,

          type: "end_customer",
        })
      );

      //set-the-fields
      store.dispatch(
        setOBJ({ path: "account", value: oot_response.data.end_customer.nid })
      );
      store.dispatch(
        setOBJ({
          path: "endCustomer",
          value: oot_response.data.end_customer.nid,
        })
      );

      store.dispatch(
        setOBJ({
          path: "endCustomer_account_nid",
          value: oot_response.data.end_customer.account_nid,
        })
      );
      break;
    case "RES":
      // alert('RES')
      store.dispatch(
        updateAccount({
          id: oot_response.data.reseller.nid,
          value: oot_response.data.reseller.name,
          account_id: oot_response.data.end_customer.account_id,
          type: "account",
        })
      );
      store.dispatch(
        updateAccount({
          id: oot_response.data.end_customer.nid,
          value: oot_response.data.end_customer.name,

          type: "end_customer",
        })
      );
      store.dispatch(
        updateAccount({
          id: oot_response.data.reseller.nid,
          value: oot_response.data.reseller.name,
          type: "resellers",
        })
      );

      store.dispatch(
        setOBJ({ path: "account", value: oot_response.data.reseller.nid })
      );
      store.dispatch(
        setOBJ({
          path: "endCustomer",
          value: oot_response.data.end_customer.nid,
        })
      );
      store.dispatch(
        setOBJ({
          path: "endCustomer_name",
          value: oot_response.data.end_customer.name,
        })
      );
      store.dispatch(
        setOBJ({
          path: "endCustomer_account_nid",
          value: oot_response.data.end_customer.account_nid,
        })
      );
      store.dispatch(
        setOBJ({ path: "resellers", value: oot_response.data.reseller.nid })
      );

      //set-the-fields

      break;
    case "DIS":
      store.dispatch(
        updateAccount({
          id: oot_response.data.distributor.nid,
          value: oot_response.data.distributor.name,
          account_id: oot_response.data.end_customer.account_id,
          type: "account",
        })
      );
      //   id: oot_response.data.distributor.nid,
      //   value: oot_response.data.distributor.name,
      //   type: "account",
      // },'result=>',store.getState().authSlice.system.account)
      store.dispatch(
        updateAccount({
          id: oot_response.data.distributor.nid,
          value: oot_response.data.distributor.name,
          type: "distributor",
        })
      );
      store.dispatch(
        updateAccount({
          id: oot_response.data.end_customer.nid,
          value: oot_response.data.end_customer.name,

          type: "end_customer",
        })
      );
      store.dispatch(
        setOBJ({
          path: "endCustomer_account_nid",
          value: oot_response.data.end_customer.account_nid,
        })
      );
      store.dispatch(
        setOBJ({
          path: "endCustomer_account_nid",
          value: oot_response.data.end_customer.account_nid,
        })
      );
      store.dispatch(
        updateAccount({
          id: oot_response.data.indirect_reseller.nid,
          value: oot_response.data.indirect_reseller.name,
          type: "indirect_resellers",
        })
      );
      //set-the-fields
      store.dispatch(
        setOBJ({ path: "account", value: oot_response.data.distributor.nid })
      );
      store.dispatch(
        setOBJ({
          path: "distributor",
          value: oot_response.data.distributor.nid,
        })
      );
      store.dispatch(
        setOBJ({
          path: "endCustomer",
          value: oot_response.data.end_customer.nid,
        })
      );
      store.dispatch(
        setOBJ({
          path: "indirect_resellers",
          value: oot_response.data.indirect_reseller.nid,
        })
      );
      break;
    default:
      break;
  }
};

export const handleExceptionR6InternalLogic = (state) => {
  if (state.findCase.data.caseType === Object.keys(caseTypesMap)[3] && state.authSlice.system.account.length > 0) {
    store.dispatch(setData({ key: "sales_channel", value: "DIR" }));
    store.dispatch(
      setAccount(
        state.authSlice.system.account.filter((e) => e?.value?.toLowerCase()?.includes("nokia"))
      )
    );
    return true; //if this logic is executing
  }
};

export const handleCaseDepSaleChannelLogic = (state) => {
  if (state.findCase.data.caseType === "frame_agreement") {
    var found = state.authSlice.system.currentState;
    var copyFound = Object.assign({}, found);
    let salesChannel = state.caseDetails.data.sales_channel;

    switch (salesChannel) {
      case "DIR":
        copyFound = {
          ...copyFound,
          fieldsRequired: { ...copyFound.fieldsRequired, endCustomer: true },
        };
        copyFound.fieldsRequired.distributor = false;
        copyFound.fieldsRequired.resellers = false;
        break;
      case "DIS":
        copyFound = {
          ...copyFound,
          fieldsRequired: { ...copyFound.fieldsRequired, endCustomer: false },
        };
        copyFound.fieldsRequired.distributor = true;
        copyFound.fieldsRequired.resellers = false;
        break;
      case "RES":
        copyFound = {
          ...copyFound,
          fieldsRequired: { ...copyFound.fieldsRequired, endCustomer: false },
        };
        copyFound.fieldsRequired.distributor = false;
        copyFound.fieldsRequired.resellers = true;
        break;
      default:
    }
    store.dispatch(changeAppState(copyFound));
  }
};

export const generateEOTRedirect = (redirect_uri) => {
  //step 1
  const dbName = toolRedirect.ENSO.dbName;
  const redirectURi = redirect_uri; //redirect.homePage;
  //step 2
  const encodedParams = encodeBase64(`${dbName}&redirect_uri=${redirectURi}`);
  //step 3
  const loginMSALAuth = `https://login.microsoftonline.com/${toolRedirect.ENSO.tenantID}/oauth2/v2.0/authorize?scope=User.Read&response_type=code&client_id=${toolRedirect.ENSO.clientID}&redirect_uri=${toolRedirect.ENSO.domain}/auth_oauth/microsoft&state=${encodedParams}`;
  return loginMSALAuth;
};
export const handleRedirectType = (state: RootState) => {
  // const authSelector = state.authSlice;
  const caseDetailsSelector = state.caseDetails
  const findCaseSelector = state.findCase
  // const cartBoqSelector = state.cartBoq
  const businessSelector = state.business;

  try {
    var caseType = findCaseSelector.data.caseType;
    var subType = findCaseSelector.data.subType;
    var customerSegment = businessSelector.data.options.PTDAC.caseIndustry;
    var advanceFeatures = businessSelector.data.view.PTDAC.additionalFeature;
    if (Object.keys(caseSubTypes).includes(caseType)) {
      var caseTypeSubTypeKeysArray = caseSubTypes[caseType].map(
        (obj, caseIndex) => ({
          caseType: obj.types
            .map(
              (typeObj, index) =>
                typeObj.key === subType && { subType: typeObj.key, id: index }
            )
            .filter((z) => z !== false),
          caseIndex: caseIndex,
        })
      );
      var caseTypeSubTypeKeys = caseTypeSubTypeKeysArray
        .flatMap((z) => z)
        .filter((z) => z.caseType.length !== 0)[0];
      if (caseTypeSubTypeKeys) {
        //get the redirect type by reaching the node in caseSubTypes in system;
        var redirect = caseTypeSubTypeKeys
          ? caseSubTypes[caseType][caseTypeSubTypeKeys.caseIndex].redirect
          : null;
        if (subType === "help") {
          //If Redirect is not defined, user selects:
          if (mpwSegmentSolution.includes(customerSegment)) {
            //If Solution is "MPW-S", system sets Redirect = EnSo shop
            redirect = toolRedirect.ENSO;
          } else {
            //Solution is undefined:
            redirect = toolRedirect.OOT;
            if (advanceFeatures.length > 0) {
              //If any Advance features are needed, system sets Redirect = EnSo shop, otherwise, system sets Redirect = OOT
              redirect = toolRedirect.ENSO;
            }
          }
        }

        if (state.dynamic.data.reference_solution.solution === "MPW") {
          redirect = redirect = toolRedirect.OOT;
          return redirect
        }

        if (redirect === null) {
          //If Redirect is not defined, user selects:

          if (caseDetailsSelector.data.extensionTool === extensionOfferTools.NDAC) {
            //"Packaged Plug & Play as-a-service solution (NDAC)".(Renamed to - NDAC Compact) System sets Redirect = OOT.
            redirect = redirect = toolRedirect.OOT;
          }
          if (
            caseDetailsSelector.data.extensionTool === extensionOfferTools.MPW_GSM
          ) {
            //"Packaged Plug & Play as-a-service solution (NDAC)".(Renamed to - NDAC Compact) System sets Redirect = OOT.
            redirect = redirect = toolRedirect.ENSO;
          }
        }
        return redirect;
      }
      if (caseTypeSubTypeKeys === undefined) {
        //handle no-subtype scenario - DEMAN/FRAME-agremments
        redirect = caseSubTypes[caseType][0].redirect;
        return redirect;
      }
    } else {
      alert('Error Creating:Looks like Casetype & subtype is not selected ')
    }
  } catch (error) {
    store.dispatch(
      setError({
        key: "error",
        value: { errorMsg: error, errorCode: null },
      })
    );
  } finally {

  }
};

const getBoqForContainers = (data, dynamicList, boq_list, key, state, getListOfFields) => {
  const containerFields = { ...data[1]['field_details'] };
  Object.entries(containerFields).map((data, _index) => {
    const perfield = dynamicList[key][data[1]['id']];
    data[1]['type'] === 'composite' ? getCompositeBoq(data, boq_list, state) : getBoqList(perfield, data, boq_list, state, getListOfFields);
  });
}

const getBoqForSubsteps = (data, dynamicList, boq_list, key, state, getListOfFields) => {
  const containerFields = { ...data[1]['field_details'] };
  Object.entries(containerFields).map((data, _index) => {
    if (data[1]['type'] === 'container') {
      getBoqForContainers(data, dynamicList, boq_list, key, state, getListOfFields);
    } else {
      //  if fields are outside of containers itself
      const perfield = dynamicList[key][data[1]['id']];
      getBoqList(perfield, data, boq_list, state, getListOfFields);
    }
  });
}

export const getBoqOptions = (state, getListOfFields) => {
  let dynamicList = state.dynamic.data.element
  let boq_list = {};
  const packagesList = state.config_stepper.data.solution_form_data.packages;

  if (packagesList && !_.isEmpty(dynamicList)) {
    Object.keys(packagesList).forEach(function (key) {
      const fieldDetails = packagesList[key].field_details;
      if (fieldDetails && !_.isEmpty(fieldDetails)) {
        Object.entries(fieldDetails).map((data, _index) => {
          //  if fields are inside a container
          if (data[1]['type'] === 'container') {
            getBoqForContainers(data, dynamicList, boq_list, key, state, getListOfFields);
          } else if (data[1]['type'] === 'details' || data[1]['type'] === 'fieldset') {
            // if the fields are inside the substeps / inside the tab view
            getBoqForSubsteps(data, dynamicList, boq_list, key, state, getListOfFields);
          }
          else {
            //  if fields are outside itself
            const perfield = dynamicList[key][data[1]['id']];
            getBoqList(perfield, data, boq_list, state, getListOfFields);
          }
        })
      }
    });
  }
  return boq_list
}

const getVisibilityOfElement = (data, state, getListOfFields) => {
  const allfieldData = getListOfFields && getListOfFields(state.dynamic.data.element);
  const allStates = getStateOfElement(data[1], allfieldData);
  return allStates;
}

const getModalData = (obj, key) => {
  if (_.has(obj, key)) {
    return _.get(obj, key);
  }
  return _.reduce(obj, (result, value) => {
    if (result) return result; // If found, return immediately
    if (_.isObject(value)) {
      return getModalData(value, key);
    }
    return result;
  }, null);
}

const getCompositeBoq = (data, boq_list, state) => {
  let compositeKey = data[1]['form_callback']['form_identifier'];
  compositeKey = compositeKey.replace(/-$/, '');
  const modalData = getModalData(state.dynamic.data.modal, compositeKey);
  // state.dynamic.data.modal[state.config_stepper.data.activeStep][state.config_stepper.data.activeSubStep][compositeKey];
  _.map(modalData, (eachData, key) => {
    _.map(eachData, (perfield, attr) => {
      // boq_list[data[1]['label']] = attr;
      const jkey = data[1]['label'] + '-' + key;
      if (!boq_list[jkey]) {
        boq_list[jkey] = {};
      }
      boq_list[jkey][attr] = perfield.value !== undefined ? perfield.value : perfield;
    });
  });
}

const getBoqList = (perfield, data, boq_list, state, getListOfFields) => {
  const visibileValue = data[1]['type'] === 'hidden' ? 'none' : getVisibilityOfElement(data, state, getListOfFields);
  if (perfield !== '' && visibileValue['visibility'] === 'block') {
    if (data[1]['type'] === 'checkbox' && data[1]['multiple']) {
      if (_.isObject(perfield) && perfield['value']) {
        boq_list[data[1]['label']] = perfield['value'];
      } else if (_.some(perfield, 'value')) {
        boq_list[data[1]['label']] = perfield.map((item) => item.value);
      } else {
        boq_list[data[1]['label']] = _.flatMap(perfield, array =>
          _.chain(array)
            .filter({ checked: true })
            .map(obj => _.pick(obj, ['product_code', 'quantity']))
            .value()
        );
      }
    } else if (data[1]['type'] === 'checkbox') {
      boq_list[data[1]['label']] = (typeof (perfield) !== 'object') ? perfield.map((item) => item.value) : (perfield).value;
    } else if (data[1]['type'] === 'select' && data[1]['multiple']) {
      boq_list[data[1]['label']] = _.map(perfield, 'value');
    } else if (data[1]['type'] === 'radio' && typeof (perfield) === 'object') {
      if (_.some(perfield, 'value')) {
        boq_list[data[1]['label']] = perfield.map((item) => item.value);
      } else if (perfield.value) {
        boq_list[data[1]['label']] = perfield.value;
      } else {
        boq_list[data[1]['label']] = _.flatMap(perfield, array =>
          _.chain(array)
            .filter({ checked: true })
            .map(obj => _.pick(obj, ['product_code', 'quantity']))
            .value()
        );
      }
    } else {
      if (data[1]['type'] === 'markup') {
        // as we have markup as notes for that check if label is there else make it blank
        //  as markup is for MXIE also it will conflict here
        if (perfield && _.isArray(perfield)) {
          boq_list[data[1]['label']] = perfield.map(item =>
            item.label ? { label: item.label, value: item.value } : ''
          );
        }
      } else {
        boq_list[data[1]['label']] = perfield;
        if (perfield && _.has(perfield, 'value')) {
          boq_list[data[1]['label']] = perfield.value !== undefined ? perfield.value : null;
        }
      }
    }
  }
}

/**
 * Prepares a versioned Bill of Quantities (BoQ) by comparing the current cart items with the backup cart items.
 * If there are differences, it adjusts the quantities and includes any removed items with a quantity of zero.
 * 
 * @param state - The current state of the Redux store.
 * @returns An array of cart items with versioned quantities.
 */
const prepareVersionedBoq = (saleItems, backupSaleItems, isDynamicBoq = false) => {
  let boqItems = saleItems ? _.cloneDeep(saleItems) : [];

  let backupBoqItems = backupSaleItems ? _.cloneDeep(backupSaleItems) : [];

  const boqItemsLength = _.isArray(boqItems) ? boqItems.length : _.keys(boqItems)?.length;
  const backupBoqItemsLength = _.isArray(backupBoqItems) ? backupBoqItems.length : _.keys(backupBoqItems)?.length;

  // UC 1 : If cartBakupItems is empty then there is no versioning done, In that case prevQuantity = null
  // if(cartBackupItems.length === 0) return cartItems;
  // UC 2: Add prevQuantity field for each cartItems with the quantity value from cartBakupItems
  _.map(boqItems, (eachItem) => {
    let bakupItem;
    if (isDynamicBoq) {
      bakupItem = _.find(backupBoqItems, (bakupItem) => bakupItem.productCode === eachItem.productCode && bakupItem.quantity !== eachItem.quantity)
    } else {
      bakupItem = _.find(backupBoqItems, (bakupItem) => bakupItem.product_id === eachItem.product_id && bakupItem.quantity !== eachItem.quantity);
    }
    if (backupBoqItemsLength > 0 && bakupItem) {
      eachItem['prevQuantity'] = bakupItem.quantity;
      eachItem['customAction'] = CUSTOM_ACTIONS.MODIFIED; // modified action
    }
    else {
      eachItem['prevQuantity'] = null;
      eachItem['customAction'] = CUSTOM_ACTIONS.DEFAULT; // default action
    }
  });

  // UC 3: cartBackupItems.length !== cartItems.length && cartBackupItems.length > cartItems.length, 
  // then there are some items removed from the cart
  // So add those items with quantity as 0
  if (backupBoqItemsLength !== boqItemsLength && backupBoqItemsLength > boqItemsLength) {
    let removedItems;
    if (isDynamicBoq) {
      removedItems = _.filter(backupBoqItems, (bakupItem) => !_.find(boqItems, (cartItem) => cartItem.productCode === bakupItem.productCode));
    } else {
      removedItems = _.filter(backupBoqItems, (bakupItem) => !_.find(boqItems, (cartItem) => cartItem.product_id === bakupItem.product_id));
    }

    _.map(removedItems, (eachItem) => {
      eachItem['quantity'] = 0;
      eachItem['prevQuantity'] = eachItem.quantity;
      eachItem['customAction'] = CUSTOM_ACTIONS.DELETED; // deleted action
      boqItems.push(eachItem);
    });
  }
  return boqItems
}

const versionDynamicBoqItems = (state: RootState) => {
  let dynamicBoqItems = (state.dynamic.data && state.dynamic.data.boq) ? _.cloneDeep(state.dynamic.data.boq) : [];

  let dynamicBoqBackupItems = (state?.dynamic?.data?.["dynamicboqBakup"]) ? _.cloneDeep(state?.dynamic?.data?.["dynamicboqBakup"]) : [];

  const allboqItems = prepareVersionedBoq(dynamicBoqItems, dynamicBoqBackupItems, true);
  return allboqItems
}

export const handleOffer = async (state: RootState, getListOfFields?) => {
  const authSelector = state.authSlice;
  const caseDetailsSelector = state.caseDetails;
  const findCaseSelector = state.findCase;
  const businessSelector = state.business;
  const cartBoqSelector = state.cartBoq;

  const cartTotal = totalCost(state.cartBoq);
  const configSelector = state.config_stepper;
  const dynamicSelector = state.dynamic;

  const solutionCategory = configSelector.data.solutionCategory;
  const solutionType = configSelector.data.solutionType;

  try {
    let redirect = handleRedirectType(state);
    let contractDuration;
    let protoType = {};
    let config_mpw_params = {};
    let mpw_additional_info = {};

    let configurator_mpw_list = {}
    let mpwItems = [];
    // Prepare whether the cart items is customised or not
    // We can not use cartBoqSelector.data.isBoQEditable, there will be a drafted cart is also come in the future
    let isCustomized = (state.cartBoq.data && state.cartBoq.data["cartBakup"] && state.cartBoq.data["cartBakup"]["items"] && state.cartBoq.data["cartBakup"]["items"].length > 0) ? true : false;
    // Prepare the versionedBoQ from the redux state - compare with saved state and prepare the cart items
    let cartItems = (state.cartBoq.data && state.cartBoq.data.cart && state.cartBoq.data.cart.items) ? _.cloneDeep(state.cartBoq.data.cart.items) : [];

    let cartBackupItems = (state.cartBoq.data && state.cartBoq.data["cartBakup"] && state.cartBoq.data["cartBakup"]["items"]) ? _.cloneDeep(state.cartBoq.data["cartBakup"]["items"]) : [];

    let versionedBoQ_cartItems = prepareVersionedBoq(cartItems, cartBackupItems, false);

    // redirect to MPW when caseindustry is manufacturing/logistics and radio selected is MPW
    if (_.includes(["logistics"], businessSelector.data.options.PTDAC.caseIndustry) && configSelector.data.solutionCategory === 'MPW') {
      const changedRedirect = identifyMPWRedirect([configSelector.data.solutionCategory]).redirect
      if (changedRedirect) {
        redirect = changedRedirect
      }
    }
    else {
      if ((businessSelector.data.options.PTDAC.caseIndustry === "port" && configSelector.data.solutionCategory === 'MPW')) {
        const changedRedirect = identifyMPWRedirect([configSelector.data.solutionCategory]).redirect
        if (changedRedirect) {
          redirect = changedRedirect
        }
      }

      if (_.includes(['reference_solution', 'mining', 'manufacturing', 'port'], businessSelector.data.options.PTDAC.caseIndustry)) {
        // && configSelector.data.solution_selected === 'cmu'
        const datesData = getDateCalculated();
        config_mpw_params = {
          "segment": configSelector.data.solution_selected === 'cmu' ? "ug" : "",
          "estimated_order_date": datesData.final_est_order_date,
          "requested_deli_date": datesData.final_req_delivery_date,
          "nature_of_order": "Sales order",
          "network_details": caseDetailsSelector.data.summary && caseDetailsSelector.data.summary !== "" ? caseDetailsSelector.data.summary : "Offer",
        };
        // let allboqItems = _.cloneDeep(state.dynamic.data.boq);
        let allboqItems = versionDynamicBoqItems(state);

        // check here
        if (solutionCategory === 'MPW' && solutionType !== 'Standalone') {
          // const allboqItems = _.cloneDeep(versionedBoQ);
          // update the type from UI cart boq into original boq , as we need that for differenciating mpw and ndac items
          _.map(allboqItems, (eachItem) => {
            if (eachItem.type === "") {
              const saleItemFound = _.filter(versionedBoQ_cartItems, (uiboqItem) => uiboqItem.product_id === eachItem.productCode);
              // const saleItemFound = _.filter(cartBoqSelector.data.cart.items,(uiboqItem) => uiboqItem.product_id === eachItem.productCode);
              if (saleItemFound && saleItemFound.length > 0) {
                eachItem['type'] = saleItemFound[0].type;
              }
            }
          });
          // when solution is mpw we want to divide the cart boq based on type
          mpwItems = _.filter(allboqItems, (e) => {
            const prodId = e.productCode || e.si_code;
            const prodType = e.type || "";
            const isMPWType = _.includes(['hardware', 'software', 'end_end_services', 'product_attached_services', 'care', 'srs', 'custom_add_service', 'custom_add_product'], (prodType).toLowerCase());
            const isPSND = _.includes(prodId, 'PSND');
            const isEmptyType = prodType === "" ? true : false;

            return ((isMPWType && !isPSND) || isEmptyType);
          });
          // all items other than mpw items add in boq for ndac items
          versionedBoQ_cartItems = _.filter(allboqItems, (obj1) => {
            // Delete the si_code from the object if it is MXIE product
            // Any si_code starting with 'SKNDEDGN' should be removed
            if (obj1?.si_code && obj1.si_code.startsWith('SKNDEDGN')) {
              delete obj1.si_code;
            }
            const hasSiCode = obj1.hasOwnProperty('si_code');
            const hasMatchingProductCode = mpwItems.some(obj2 => obj1.hasOwnProperty('productCode') && obj1.productCode !== obj2.productCode);

            return !hasSiCode && hasMatchingProductCode;
          });
        }
        configurator_mpw_list = {
          items: ((configSelector.data.solution_selected === 'cmu' || configSelector.data.solution_selected === 'evc') ? allboqItems : (mpwItems.length > 0 ? mpwItems : [])),
          // items: (configSelector.data.solution_selected === 'cmu' ? versionedBoQ : (mpwItems.length > 0 ? mpwItems : [])),
          partner_accredits: (dynamicSelector.data.boq && dynamicSelector.data.boq[0] && dynamicSelector.data.boq[0].partner_accredits) ? dynamicSelector.data.boq[0].partner_accredits : "",
          dod_applicable: (dynamicSelector.data.boq && dynamicSelector.data.boq[0] && dynamicSelector.data.boq[0].dod_applicable) ? dynamicSelector.data.boq[0].dod_applicable : "",
          incoterm: "",
          boq_options: getBoqOptions(state, getListOfFields) // this has been complicated , we can make another dataset with values when add to cart and use it here
        }
        // send package count value from redux in boq_options, for MPW soln there will be value count , in case of NDAC send it as 1
        configurator_mpw_list['boq_options']['package_options_count'] = dynamicSelector.data?.package_options_count ? dynamicSelector.data.package_options_count : 1;
      }
      if ((_.includes(['reference_solution', 'mining', 'manufacturing', 'port'], businessSelector.data.options.PTDAC.caseIndustry) && configSelector.data.solution_selected !== 'cmu' && redirect.id != "ENSO")) {
        const slaWarrantyProds = ndac_fetchSlaWarrantyProducts(cartBoqSelector, dynamicSelector, businessSelector);
        contractDuration = dynamicSelector.data.reference_solution.contract_duration;
        const serviceItems = cartBoqSelector.data.cart.items.filter((e) => e.type === "end_end_services" || e.type === "custom_add_service" || (e?.cui_type === "service"));
        // filter das items only from cart boq items
        const dasItems = cartBoqSelector.data.cart.items.filter((e) => e.financialProduct === "DAS_Pricing");
        protoType = {
          "services": generateSyncOfferItems('services', serviceItems, contractDuration, dynamicSelector),
          "boq": generateSyncOfferItems('ndac', versionedBoQ_cartItems, undefined, dynamicSelector),
          "type": 'ndac',
          "total_prod_cost": cartTotal,
          "ndac_premium_addons": slaWarrantyProds
        }
        protoType['services'] = [...protoType['services'], ...generateSyncOfferItems('das', dasItems, contractDuration, dynamicSelector)];
      }
    }

    //nw_plan_id - odt planner id if available
    let offerList = {
      id: dynamicSelector.data?.offer_id ? dynamicSelector.data?.offer_id : "",
      name: caseDetailsSelector.data.caseName,
      shipping_country: caseDetailsSelector.data.shipping_country,
      sales_channel: caseDetailsSelector.data.sales_channel,
      end_customer: caseDetailsSelector.data.endCustomer,
      market: caseDetailsSelector.data.market,
      summary: caseDetailsSelector.data.summary,
      owner: authSelector.offer_owner_email?.length > 0 ? authSelector.offer_owner_email : authSelector.login.mail,
      network_location: caseDetailsSelector.data.country,
      co_owner: caseDetailsSelector.data.co_owner,
      scrm_id: !sCRMRegex.test(findCaseSelector.data.sCRMID)
        ? "19.XY.123456"
        : findCaseSelector.data.sCRMID,
      public_funding_required: caseDetailsSelector.data
        .public_funding_required
        ? "yes"
        : "no",
      reason_for_funding: caseDetailsSelector.data.public_funding_required
        ? caseDetailsSelector.data.summary
        : "NA",
      case_type: findCaseSelector.data.caseType,
      case_sub_type: findCaseSelector.data.subType,
      customerSegmentId: businessSelector.data.options.PTDAC.caseIndustry,
      budgetary: caseDetailsSelector.data.caseCategory,
      lead_product: "NDAC",
      commercial_model: findCaseSelector.data.subType === "help" ? businessSelector.data.view.PTDAC.commercial_model.toLowerCase() : caseDetailsSelector.data.commercial_model.toLowerCase(),
      contract_duration: contractDuration ? contractDuration : caseDetailsSelector.data.contract_duration,
      contracting_party_id: caseDetailsSelector.data.account,
      currency: caseDetailsSelector.data.currency,
      network_id: caseDetailsSelector.data.network_id,
      solution: configSelector.data.solution_selected,
      requested_state: 'draft',
      validationDetails: dynamicSelector.data.validationDetails ? dynamicSelector.data.validationDetails['validateResponse'] : {},
      nw_plan_id: dynamicSelector.data.reference_solution ? dynamicSelector.data.reference_solution.linkedPlanner['sys_id'] : '',
      // isCustomized is set to true if the cart is customized
      isCustomized: isCustomized,
      sid: dynamicSelector.data.sid
    }
    const termDeviation = !caseDetailsSelector?.data?.termDeviation && findCaseSelector?.data?.subType === "merchant_offer" ? false : caseDetailsSelector?.data?.termDeviation;
    // add this property when the termdeviation is set to true in the case details
    if (termDeviation !== undefined && termDeviation !== null) {
      offerList['termDeviation'] = termDeviation;
      offerList.requested_state = 'draft';
      if (termDeviation) {
        offerList.requested_state = 'pendingapproval';
        const est_date_months = 1;
        const reqDeli_date_months = 2;
        const datesData = getDateCalculated(est_date_months, reqDeli_date_months);
        offerList["estimated_order_date"] = datesData.final_est_order_date;
        offerList["requested_deli_date"] = datesData.final_req_delivery_date;
        offerList["nature_of_order"] = "internal";
      }
    }

    setStateOffer(offerList, configurator_mpw_list, protoType);

    offerList = setLeadProduct(config_mpw_params, configSelector, offerList);

    // set the offerList.requested_state to 'draft' if the cart is customized
    // --- Need to check if this is correct - on draft BoQ is coming from dashboard ?
    if (isCustomized) {
      offerList.requested_state = 'draft';
    }
 
    const dataProtoType = (_.includes(['NDAC', 'MPW'], solutionCategory) && solutionType !== 'Standalone') ?
      {
        offer: offerList,
        configurator_mpw: {
          ...configurator_mpw_list
        },
        DAC_DATA: {
          ...protoType
        },
        eot_services_response: { ...dynamicSelector.data.eot_response_syncoffer }
      } :
      {
        offer: offerList,
        configurator_mpw: {
          ...configurator_mpw_list
        }
      }

    // Append datamart ui_json with all store data
    const uiJsonObject = getUIJsonState(dynamicSelector.data?.offer_id);
    dataProtoType["ui_json"] = JSON.stringify(uiJsonObject);


    // Add the validation message to the offer data
    dataProtoType["notification_messages"] = getSavedValidationMessageList();

    if (findCaseSelector.data.subType === "help") {
      if (!businessSelector.data.options.PTDAC.caseIndustry) {
        store.dispatch(
          setError({
            key: "error",
            value: {
              errorCode: null,
              errorMsg: "Please select a customer segment",
            },
          })
        );

        return { response_code: 0, response_msg: 'Please select a customer segment' };
      }
    }

    if (redirect.hasOwnProperty('id')) {
      switch (redirect.id) {
        case "OOT":
          store.dispatch(showLoader(true));
          store.dispatch(showModal({ msg: "Offer creation in progress, Please wait..", title: "Creating Offer", show: true, variant: "WARNING" }))
          if (!authSelector.login.hasOwnProperty("accessToken")) {

            setError({
              key: "warn",
              value: {
                errorCode: null,
                errorMsg: "The accesstoken is not set,re-login is required.",
              },
            });
            return;
          }

          try {
            const responseData = await OOT.syncOffer({
              data: dataProtoType,
            });
            const response = responseData.data[0];
            const payload_backend = responseData.data[1];

            store.dispatch(showLoader(false));
            if (response.status) {
              // after offer is created , make cartboq_backup same as cartboq and dynamicBoq_backup same as dynamic boq
              store.getState().cartBoq?.data?.cart?.items?.length > 0 && store.dispatch(setProp({ slice: "cartBoq", key: "cartBakup", value: store.getState().cartBoq?.data?.cart }));
              store.getState().dynamic?.data?.boq.length > 0 && store.dispatch(setProp({ slice: "dynamic", key: "dynamicboqBakup", value: store.getState().dynamic?.data?.boq }));
              // send the all data , offer id and syncoffer payload to datamart as POST. New entry has to be added with different temp_offer_id and offer_id
              const aftersyncoffer_data = {
                offerid: response.result?.offer_id,
                payload: payload_backend,
                leadProduct: offerList?.lead_product,
              }
              const selectors = {
                caseSelector: store.getState().caseDetails,
                dynamicSelector: store.getState().dynamic,
                findSelector: store.getState().findCase,
                configStepperSelector: store.getState().config_stepper,
                authSelector: store.getState().authSlice
              };

              const datamartResp = await DATAMART_SERVICES.saveCartDetails_service(selectors, aftersyncoffer_data);
              store.dispatch(setLive(true));
              store.dispatch(showModal({ msg: `Offer: ${response.result?.offer_id} created`, title: `Offer ${response.result?.offer_id} successfully created.`, show: true }))
              await new Promise(resolve => setTimeout(resolve, 3000));
              window.open(
                redirect.urlPrefix + response.result?.offer_id + "&cui_login=ms", "_top"
              );

              //return { response_code: 1, response_msg: response.data }
              //  setTimeout(()=>handleRestLogic(),4000)

            } else {
              store.dispatch(showModal({ msg: response.errorMessage, title: "Something went wrong", show: true, variant: "ERROR" }))
              return { response_code: 0, response_msg: response.errorMessage }
            }
          } catch (err) {
            let errorMsg = "Something went wrong";
            if (err?.response?.status && err?.message) {
              errorMsg = err.response.status + ':' + err.message;
            }
            store.dispatch(showModal({ msg: errorMsg, title: "Server Error", show: true, variant: "ERROR" }))
            store.dispatch(setLive(false));
          }

          break;
        case "ENSO":
          var endCust = await OOT.getAccountCustomer({ account_nid: caseDetailsSelector.data.endCustomer_account_nid ? caseDetailsSelector.data.endCustomer_account_nid : caseDetailsSelector.data.account });
          if (!endCust?.status) {
            store.dispatch(
              setError({
                key: "error",
                value: {
                  errorCode: null,
                  errorMsg: `Failed to  get Customers for ${caseDetailsSelector.data.account}`,
                },
              })
            );
            return { response_code: 0, response_msg: 'Failed to find three_star_acc_id name' };
          }
          if (endCust?.data?.accounts?.length == 0) {
            store.dispatch(
              setError({
                key: "error",
                value: {
                  errorCode: null,
                  errorMsg: `0 Customers found for the selected account, try again.`,
                },
              })
            );
            return { response_code: 0, response_msg: 'Failed to find three_star_acc_id name' };
          }
          //let three_star_acc = endCust?.data?.customers.find((c) => c.name == authSelector.system.account[0].value)
          let three_star_acc_id = endCust?.data?.accounts[0]['3*_number'];
          if (!three_star_acc_id) {
            store.dispatch(
              setError({
                key: "error",
                value: {
                  errorCode: null,
                  errorMsg: `Exception: 3 star id for account is empty, try again.`,
                },
              })
            );
            return { response_code: 0, response_msg: 'Failed to find three_star_acc_id name' };
          }
          store.dispatch(showLoader(false));
          // dispatch(setError(null));
          if (true) {
            if (!sCRMRegex.test(findCaseSelector.data.sCRMID)) {
              store.dispatch(
                setError({
                  key: "warn",
                  value: {
                    errorCode: null,
                    errorMsg: "Empty or invalid sCRM will not work for MPW-S cases",
                  },
                })
              );
              return;
            }
            // if (caseDetailsSelector.data.caseCategory === "Budgetary") {
            //   //const loginMSALAuth =`https://login.microsoftonline.com/${toolRedirect.ENSO.tenantID}/ oauth2/v2.0/authorize?scope=User.Read&response_type=code&client_id=${proces}&redirect_uri=https://iesp.cloud-test.nokia.com/auth_oauth/Microsoft&state=`

            //   if (authSelector.role === ROLE.INTERNAL) {
            //     window.open(generateEOTRedirect(redirect.homePage), "_self");
            //   }
            //   if (authSelector.role === ROLE.PARTNER) {
            //     window.open(
            //       generateEOTRedirect(redirect.homePagePartner),
            //       "_self"
            //     );
            //   }
            //   handleRestLogic();
            //   return { response_code: 1, response_msg: 'Redirected to EOT' };
            // }

            let decodedEndCustomer = undefined;
            if (
              caseDetailsSelector.data.sales_channel === "DIR" &&
              authSelector.OOT?.data?.end_customer?.name
            ) {
              decodedEndCustomer = authSelector.OOT.data.end_customer.name;
            } else {
              const search = authSelector.system.endCustomer.find(
                (z) => z.id === caseDetailsSelector.data.endCustomer
              );
              decodedEndCustomer = search.value;
            }
            // new implementation - change endcustomer to account: 21-11-23
            const searchAccount = authSelector.system.account.find(
              (z) => z.id === caseDetailsSelector.data.account
            );
            const decodedEndAccount = searchAccount.value;
            const endCustomerData = authSelector.system.endCustomer.find((e) => e.id === caseDetailsSelector.data.endCustomer)
            if (decodedEndAccount === undefined) {
              store.dispatch(
                setError({
                  key: "error",
                  value: {
                    errorCode: null,
                    errorMsg: "Failed to find account name",
                  },
                })
              );
              return { response_code: 0, response_msg: 'Failed to find account name' };
            }
            const base64Customer = encodeBase64(decodedEndCustomer);
            const base64Account = encodeBase64(decodedEndAccount);
            const scrmid = (findCaseSelector.data.sCRMID).toUpperCase();
            if (authSelector.role === ROLE.INTERNAL) {
              const urlParms = `?case_type=${findCaseSelector.data.caseType}&case_sub_type=${findCaseSelector.data.subType}&opportunity_id=${scrmid}&segment_id=${businessSelector.data.options.PTDAC.caseIndustry === 'reference_solution' ? 'ndac_reference_solution' : businessSelector.data.options.PTDAC.caseIndustry}&3_star_number=${three_star_acc_id}`;
              //  window.location.href = redirect.urlPrefix + urlParms;
              const encodedState = encodeBase64(urlParms);
              const url = redirect.urlPrefix + "?state=" + encodedState;
              window.open(generateEOTRedirect(url), "_self");
              handleRestLogic();
              return { response_code: 1, response_msg: 'Redirected to EOT' };
            }
            if (authSelector.role === ROLE.PARTNER) {
              const urlParms = `?case_type=${findCaseSelector.data.caseType}&case_sub_type=${findCaseSelector.data.subType}&opportunity_id=${scrmid}&segment_id=${businessSelector.data.options.PTDAC.caseIndustry}`;
              //  window.location.href = redirect.urlPrefixPartner + urlParms;
              const encodedState = encodeBase64(urlParms);
              const url = redirect.urlPrefixPartner + "?state=" + encodedState;
              window.open(generateEOTRedirect(url), "_self");
              handleRestLogic();
              return { response_code: 1, response_msg: 'Redirected to EOT' };
            }
          }
          break;
        default:
          break;
      }
    }
  } catch (error) {

    store.dispatch(setStatus(STATUS.ERROR));
    setError({
      key: "error",
      value: { errorMsg: error, errorCode: null },
    });
  }
};

const setStateOffer = (offerList, configurator_mpw_list, protoType) => {
  // set requested_state to approved when only mpw items are there and there are no ndac items
  if ((configurator_mpw_list['items'] && configurator_mpw_list['items'].length > 0) && (_.isEmpty(protoType) || (protoType['boq']).length === 0)) {
    offerList.requested_state = 'approved';
  }
}

const setLeadProduct = (config_mpw_params, configSelector, offerList) => {
  if (Object.keys(config_mpw_params).length > 0) {
    // for both CMU and MPW
    if (_.includes(['MPW'], configSelector.data.solutionCategory)) {
      offerList['lead_product'] = 'MPW';
    } else if (configSelector.data.solutionCategory === 'NDAC' && configSelector.data.solution_selected === 'ndac_compact') {
      offerList['lead_product'] = 'ndac_compact';
    }
    offerList = { ...offerList, ...config_mpw_params };
  }
  return offerList;
}

const getDateCalculated = (estimationMonths = undefined, reqDeliMonths = undefined) => {
  const est_order_addMonths = estimationMonths !== undefined ? estimationMonths : 2;
  const req_delivery_addMonths = reqDeliMonths !== undefined ? reqDeliMonths : 6;

  // estimated date will be current date + 2 months
  let current_est_date = new Date();
  current_est_date.setMonth(current_est_date.getMonth() + est_order_addMonths);
  const est_order_date = current_est_date.getMonth() + 1;
  const estyear = current_est_date.getFullYear();
  const estdate = current_est_date.getDate();

  // requested date will be current date + 6 months
  let current_req_date = new Date();
  current_req_date.setMonth(current_req_date.getMonth() + req_delivery_addMonths);
  const req_delivery_date = current_req_date.getMonth() + 1;
  const reqyear = current_req_date.getFullYear();
  const reqdate = current_req_date.getDate();

  const est_order_month = est_order_date < 10 ? '0' + est_order_date : '' + est_order_date;
  const req_delivery_month = req_delivery_date < 10 ? '0' + req_delivery_date : '' + req_delivery_date;

  const finalestdate = estdate < 10 ? '0' + estdate : '' + estdate;
  const finalreqdate = reqdate < 10 ? '0' + reqdate : '' + reqdate;

  const est = `${estyear}-${est_order_month}-${finalestdate}`;
  const req_delivery = `${reqyear}-${req_delivery_month}-${finalreqdate}`;

  return { 'final_est_order_date': est, 'final_req_delivery_date': req_delivery };
}

/**
 * Get the saved validation message list from the dynamic store.
 *
 * @returns {Array} - The list of saved validation messages.
 */

const getSavedValidationMessageList = () => {
  // Get the current state
  const reduxStore = store.getState();
  const dynamicSelector = reduxStore.dynamic;
  // Ensure safe access by providing empty arrays as defaults
  const notificationMessages = dynamicSelector?.data?.notification_messages;
  let result = [];
  // Traverse the object and extract the warning and information messages
  function traverse(node) {
    if (Array.isArray(node)) {
      node.forEach(item => {
        if (item.type === "warning" || item.type === "information") {
          result.push(item);
        }
      });
    } else if (typeof node === "object" && node !== null) {
      Object.values(node).forEach(traverse);
    }
  }

  // If there are no messages, return an empty array
  if (_.isEmpty(notificationMessages)) {
    console.log("inside if block")
    return [];
  }
  // Call the recursive function
  traverse(notificationMessages);
  return result;
};

export const fetchAccountData = async (state: RootState) => {
  const caseDetailsSelector = state.caseDetails;
  const account_nid_value = caseDetailsSelector.data.endCustomer_account_nid ? caseDetailsSelector.data.endCustomer_account_nid : caseDetailsSelector.data.account;

  var endCust = await OOT.getAccountCustomer({ account_nid: account_nid_value });
  if (!endCust?.status) {
    store.dispatch(
      setError({
        key: "error",
        value: {
          errorCode: null,
          errorMsg: `Failed to  get Customers for ${caseDetailsSelector.data.account}`,
        },
      })
    );
    return { response_code: 0, response_msg: 'Failed to find three_star_acc_id name' };
  }
  if (endCust?.data?.accounts?.length == 0) {
    store.dispatch(
      setError({
        key: "error",
        value: {
          errorCode: null,
          errorMsg: `0 Customers found for the selected account, try again.`,
        },
      })
    );
    return { response_code: 0, response_msg: 'Failed to find three_star_acc_id name' };
  }
  let three_star_acc_id = endCust?.data?.accounts[0]['3*_number'];
  if (!three_star_acc_id) {
    store.dispatch(
      setError({
        key: "error",
        value: {
          errorCode: null,
          errorMsg: `Exception: 3 star id for account is empty, try again.`,
        },
      })
    );
    return { response_code: 0, response_msg: 'Failed to find three_star_acc_id name' };
  } else {
    const accountName = endCust?.data?.accounts[0]['name'];
    const account_one_star_number = endCust?.data?.accounts[0]['1*_number'];
    store.dispatch(setOBJ({ path: "account_name", value: accountName }));
    store.dispatch(setOBJ({ path: "three_star_number", value: three_star_acc_id }));
    store.dispatch(setOBJ({ path: "account_one_star_number", value: account_one_star_number }));
  }
}

// export const fetchSlaWarrantyProducts = (warrantySelector, stateMachineSelector,businessSelector) => {
//   const planselected = warrantySelector?.data?.options?.PTDAC?.subscription_plan;
//   const slawarrantyData = stateMachineSelector?.PTDAC?.selected?.warranty;
//   if (!slawarrantyData) {
//     return
//   }
//   let warrantyProds = [];
//   if (slawarrantyData.extendDurationWarrantyTab?.data && warrantySelector?.data?.options?.PTDAC?.warranty[1]) {
//     warrantyProds = slawarrantyData?.extendDurationWarrantyTab?.data?.products;
//   }
//   let slaProds = [];
//   if (slawarrantyData?.plansWarrantyTab?.data?.plans?.byPlan[planselected]) {
//     slaProds = slawarrantyData?.plansWarrantyTab?.data?.plans?.byPlan[planselected]?.products;
//   }
//   const slawarrantyProds = warrantyProds.concat(slaProds);
//   const addonArray = [];
//   slawarrantyProds.forEach(eachProd => {
//     if(eachProd) {
//       const prodObj = {
//         "product_code": eachProd.product_id,
//         "quantity": eachProd.quantity,
//         "duration": (eachProd.type === 'service' || eachProd.category === 'sla') ? warrantySelector.data.options.PTDAC.subscription_duration : "NA",
//         "type": eachProd.type === 'service' ? 'support' : (eachProd.category === 'sla' ? 'support' : eachProd.type)
//       }
//       if(businessSelector.data.view.PTDAC.commercial_model === "capex") {
//         prodObj["extended_years"] = eachProd.type === 'warranty' ? warrantySelector.data.options.PTDAC.warranty[1] : "NA";
//       } else {
//         prodObj["extended_month"] = eachProd.type === 'warranty' ? warrantySelector.data.options.PTDAC.warranty[1] * 12 : "NA";
//       }
//       addonArray.push(prodObj);
//     }
//   });
//   return addonArray;
// }

export const ndac_fetchSlaWarrantyProducts = (cartBoqSelector, dynamicSelector, businessSelector) => {
  // const slaInput = dynamicSelector?.data?.element?.sla_warranty ? dynamicSelector?.data?.element?.sla_warranty : dynamicSelector?.data?.element?.care_srs_sla_warranty;

  // Take warranty and sla products from cartBoQ Selector as they are the latest BoQ
  let slawarrantyProds = [];
  /* Special rule for NDAC Compact : No warranty and SLA products to be sent in ndac_premium_addons
  SLA item has to be sent in ndac_items , as at oot end this will be added in ndac items and addons will 
  be added automatically by OOT */
  if (dynamicSelector.data.reference_solution.commercial_model !== "operating_lease") {
    slawarrantyProds = _.filter(cartBoqSelector.data.cart.items, (obj) => (
      obj.type === 'warranty' ||
      obj.category === 'warranty') ||
      (
        obj.category === 'sla' ||
        obj.type === 'sla' ||
        isHardwareSLAItem(obj)
      ));
  }
  const addonArray = [];
  // const sla_dur = slaInput.subscription_duration_months_opex ? slaInput.subscription_duration_months_opex : (slaInput.subscription_duration_years_capex ? slaInput.subscription_duration_years_capex : slaInput.subscription_duration_months_operating_lease);


  slawarrantyProds.forEach(eachProd => {
    let typename = 'support';
    let durationValue = businessSelector.data.view.PTDAC.commercial_model === "capex" ? eachProd.duration * 12 : eachProd.duration;
    if (eachProd.category === 'warranty' || eachProd.type === 'warranty') {
      typename = 'warranty';
      durationValue = eachProd.duration
    }

    // Set the duration  and type for For HW SLA sale items
    if (isHardwareSLAItem(eachProd)) {
      typename = 'sla';
      durationValue = eachProd.duration
    }

    const prodObj = {
      "product_code": eachProd.product_id,
      "quantity": eachProd.quantity,
      "duration": durationValue,
      "type": typename
    }
    if (businessSelector.data.view.PTDAC.commercial_model === "capex") {
      // prodObj["extended_years"] = slaInput.extend_warranty_by ? slaInput.extend_warranty_by.value : "NA"
      prodObj["extended_years"] = prodObj.duration ? prodObj.duration : "NA";
    } else {
      // prodObj["extended_month"] = slaInput.extend_warranty_by ? slaInput.extend_warranty_by.value * 12 : "NA"
      prodObj["extended_month"] = prodObj.duration ? prodObj.duration : "NA";
    }
    addonArray.push(prodObj);
  });
  return addonArray;
}

export const identifySolutionRedirect = (combinations) => {
  // for CDM UG MPW redirect to EOT
  if (combinations.includes(fullMiningType.byIds.underground.id) && combinations.includes(fullSolType.byIds.mpw.id)) {
    return { next: false, redirect: toolRedirect.ENSO } //"redirect_mpw"
  }
  return { next: true, redirect: null }
}

export const identifyMPWRedirect = (combinations) => {
  // for the selected solution if type is not NDAC then redirect to EOT
  if (!combinations.includes(fullSolType.byIds.ndac.value)) {
    return { next: false, redirect: toolRedirect.ENSO } //"redirect_mpw"
  }
  return { next: true, redirect: null }
}